export const yardLocations = [
    'OMSS', 'Con Global', 'PCC', 'OICT', 'ETS', 'TRAPAC', 'MATSON', 'United Intermodal', 'BridgePort', 'AMCO Yard', 'ASC Allied Storage', 'BNSF', 'Conewest', 'Fastlane Intermodal', 'GSC Yard',
];